import InvoiceUseHistory from '@/entity/InvoiceUseHistory';
/**
 * 매출 > 사용내역서 뷰모델
 */
export default class InvoiceUseHistoryVM extends InvoiceUseHistory {
    // eslint-disable-next-line no-useless-constructor
    constructor(data) {
        super(data);
    }
}
